import React from 'react';
import { motion } from 'framer-motion';
import { CiWarning } from 'react-icons/ci';

interface ReservationFailurePopupProps {
  isOpen: boolean;
  message: string;
  onClose: () => void;
  onTryAgain: () => void;
}

const ReservationFailurePopup: React.FC<ReservationFailurePopupProps> = ({
  isOpen,
  message,
  onClose,
  onTryAgain,
}) => {

  if (!isOpen) return null;

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="fixed inset-0 flex items-center justify-center z-50 bg-black/30"
      onClick={onClose}
    >

      <motion.div
        initial={{ scale: 0.8, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        exit={{ scale: 0.8, opacity: 0 }}
        className="bg-white dark:bg-[#4A5568] rounded-[1.5rem] p-8 max-w-md mx-4 shadow-2xl"
        onClick={(e) => e.stopPropagation()}
      >

        <div className="text-center">

          <div className="w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4 bg-red-100 dark:bg-red-900/30">
            <CiWarning className="h-12 w-12 text-red-500" />
          </div>


          <h3 className="text-2xl font-bold text-gray-800 dark:text-gray-200 mb-4">
            {message}
          </h3>


          <button
            onClick={onTryAgain}
            className="w-full bg-[#FF6347] hover:opacity-90 text-white py-3 px-4 rounded-lg font-semibold transition-opacity"
          >
            Try Another Time
          </button>

        </div>

      </motion.div>

    </motion.div>
  );
};

export default ReservationFailurePopup;